<div class="chart-subtitle" [ngClass]="{ hidden: !hasTitle }">
  {{ 'dashboard.studentsProgress' | translate }}
  <gl-tooltip posBottom [text]="tooltipText"></gl-tooltip>
</div>
<div class="row flex-center align-center">
  <ng-container>
    <div class="col s6 m8">
      <div class="block-charts charts-canvas">
        <lms-chart
          class="block bar-chart"
          [charType]="'doughnut'"
          [data]="canvasData"
          [labels]="tooltipLabels"
          [colors]="chartColors"
          [legend]="false"
          [options]="chartOptions"
        >
        </lms-chart>
        <div *ngIf="totals && totals.total" class="chart-subtitle padding-bottom_none">
          {{ totals.total }} {{ 'dashboard.students' | translate }}
        </div>
      </div>
    </div>
    <div class="col s6 m4" *ngIf="totals.created">
      <ul class="chart-list-colors">
        <li *ngFor="let label of licenseStatusKeys; let i = index">
          <span class="color" [ngClass]="legendColors[i]"></span>
          <span class="label">{{ 'groups.dashboard.legend.' + label | translate }}</span>
        </li>
      </ul>
    </div>
  </ng-container>
</div>
